<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      width="30px"
      height="30px"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M693.881905 282.819048h142.872381v589.531428c0 29.500952-23.893333 53.638095-53.638096 53.638095H211.626667c-29.500952 0-53.638095-23.893333-53.638096-53.638095v-714.361905c0-29.500952 23.893333-53.638095 53.638096-53.638095H658.285714v142.872381h35.84V282.819048z m-53.638095-17.798096V122.148571H211.626667c-19.748571 0-35.84 16.091429-35.84 35.84v714.361905c0 19.748571 16.091429 35.84 35.84 35.84h571.489523c19.748571 0 35.84-16.091429 35.84-35.84V300.617143h-142.87238v-35.84h-35.84z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M667.062857 300.617143h-26.819047V104.106667h17.798095V121.904762h17.798095v17.798095h17.798095v17.798095h17.798095V175.542857h17.798096v17.798095h17.798095v17.798096h17.798095V229.180952h17.798095v17.798096h17.798096v17.798095h17.798095v17.798095h17.798095v17.798095h-196.510476v-26.819047c0.731429 14.628571 13.165714 27.062857 27.550476 27.062857z m0 0M229.424762 818.712381h535.893333v35.84H229.424762v-35.84z m0-89.234286h535.893333v35.84H229.424762v-35.84z m0-89.478095h535.893333v35.84H229.424762v-35.84z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M140.190476 193.584762h285.744762c19.748571 0 35.84 16.091429 35.84 35.84v285.744762c0 19.748571-16.091429 35.84-35.84 35.84H140.190476c-19.748571 0-35.84-16.091429-35.84-35.84V229.180952c0-19.504762 16.091429-35.59619 35.84-35.59619z m0 0"
        fill="#5C76B8"
      />
      <path
        d="M390.339048 265.020952c-7.070476 0-17.798095 5.36381-17.798096 16.091429v137.508571l-80.457142-80.457142h-1.950477l-1.706666-1.706667c-1.706667 0-5.36381-1.706667-9.020953 0h-5.363809c-1.706667 0-1.706667 1.706667-1.706667 1.706667l-78.506667 82.163809V282.819048c0-12.434286-10.727619-16.091429-17.798095-16.091429-7.070476 0-16.091429 3.657143-16.091428 16.091429v184.07619c0 7.070476 5.36381 14.384762 12.434285 16.091429 3.657143 0 9.020952 0 12.434286-3.657143l99.961905-98.255238 101.912381 98.255238c1.706667 1.706667 3.657143 1.706667 3.657143 3.657143 1.706667 0 3.657143 1.706667 5.363809 1.706666 7.070476 0 14.384762-7.070476 14.384762-16.091428v-187.489524c-1.950476-12.678095-12.678095-16.091429-19.748571-16.091429z m0 0"
        fill="#FFFFFF"
      />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
